import { GridColumnModel } from '../utils/common-interface';

export interface BulkActivitiesGridNames {
    countName: string;
    actionName: string;
    createdOnName: string;
    createdByName: string;
    statusName: string;
}

const getGridNames = (
    defaultNames: BulkActivitiesGridNames,
    nameOverrides: Partial<BulkActivitiesGridNames> = {}
): BulkActivitiesGridNames => ({ ...defaultNames, ...nameOverrides });

const defaultBulkActivitiesGridNames: BulkActivitiesGridNames = {
    countName: 'No of ISKU',
    actionName: 'Actions',
    createdOnName: 'Created On',
    createdByName: 'Created By',
    statusName: 'Status'
};

export const bulkActivitiesGridList = (
    nameOverrides: Partial<BulkActivitiesGridNames> = {}
): GridColumnModel[] => {
    const names = getGridNames(defaultBulkActivitiesGridNames, nameOverrides);

    return [
        {
            id: 1,
            name: names.countName,
            isChecked: true,
            map: 'total_count',
            method: 'parseCount',
            allowHtml: true
        },
        {
            id: 2,
            name: names.actionName,
            isChecked: true,
            map: 'activity_name',
            method: 'parseBulkAction',
            allowHtml: true
        },
        {
            id: 3,
            name: names.createdOnName,
            isChecked: true,
            map: 'performed_on',
            method: 'formatSimpleDate'
        },
        {
            id: 4,
            name: names.createdByName,
            isChecked: true,
            map: 'performed_by'
        },
        {
            id: 5,
            name: names.statusName,
            isChecked: true,
            map: 'total',
            parseComponent: 'bulkActivityStatus'
        }
    ];
};

const defaultKitBulkActivitiesGridNames: BulkActivitiesGridNames = {
    countName: 'No. of Records',
    actionName: 'Actions',
    createdOnName: 'Created On',
    createdByName: 'Performed by',
    statusName: 'Status'
};

export const kitBulkActivitiesGridList = (
    nameOverrides: Partial<BulkActivitiesGridNames> = {}
): GridColumnModel[] => {
    const names = getGridNames(defaultKitBulkActivitiesGridNames, nameOverrides);

    return [
        {
            id: 1,
            name: names.countName,
            isChecked: true,
            map: 'total_records',
            method: 'parseCount',
            allowHtml: true
        },
        {
            id: 2,
            name: names.actionName,
            isChecked: true,
            map: 'name',
            method: 'parseBulkAction',
            allowHtml: true
        },
        {
            id: 3,
            name: names.createdOnName,
            isChecked: true,
            map: 'created_at',
            method: 'formatMomentDate'
        },
        {
            id: 4,
            name: names.createdByName,
            isChecked: true,
            map: 'created_by'
        },
        {
            id: 5,
            name: names.statusName,
            isChecked: true,
            map: 'total',
            parseComponent: 'bulkKitActivityStatus'
        }
    ];
};


export const productsBulkActivitiesNavList = (): any[] => {
    return [
        {
            name: 'Inventory',
            route: `/products/bulkactivity/bulk-activities`
        },
        {
            name: 'Offline Kit',
            route: `/products/bulkactivity/offline-kit-bulk-activities`
        },
        {
            name: 'Kit/Bundle',
            route: `/products/bulkactivity/kit-bulk-activities`
        },
        {
            name: 'iSKU Merge',
            route: `/products/bulkactivity/isku-bulk-activities`
        },
        {
            name: 'Id Un-mapping',
            route: `/products/bulkactivity/id-unmapping-bulk-activities`
        }
    ];
}